import React from 'react';
import './Medici.css';

function Medici() {
  return (
    <div className="coming-soon-page">
      <div className="coming-soon-content">
        <div className="coming-soon-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <h1 className="coming-soon-title">În curând</h1>
        <p className="coming-soon-text">Secțiunea dedicată medicilor este în curs de dezvoltare.</p>
      </div>
    </div>
  );
}

export default Medici;
